import { Outlet, useNavigate } from 'react-router';

import { AppShellLayoutComponent } from '@workinance/shared/ui/AppShellLayoutComponent';
import { DashboardIcon, PersonIcon } from '@workinance/shared/ui/icons';
import { NotificationBellComponent } from '@workinance/shared/ui/NotificationBellComponent';
import { UserMenuComponent } from '@workinance/shared/ui/UserMenuComponent';
import { getUserTypeLabel } from '@workinance/shared/utility/user';

import { navigation } from '@/components/admin/navigation';
import { dashboardUrl } from '@/config';
import { useAuthStore } from '@/store/auth.store';

/** Admin has only a few pages, so they sit as pills in the top bar rather than in a side navigation. */
export function AdminLayoutComponent() {
	const navigate = useNavigate();
	const user = useAuthStore((state) => state.user);
	const logout = useAuthStore((state) => state.logout);

	const handleLogout = () => {
		logout();
		navigate('/login', { replace: true });
	};

	return (
		<AppShellLayoutComponent
			homePath="/dashboard"
			primaryNavigation={navigation}
			accountMenu={
				<>
					<NotificationBellComponent />
					<UserMenuComponent
						firstName={user?.firstName}
						surName={user?.surName}
						subtitle={getUserTypeLabel(user) || undefined}
						items={[
							{
								label: 'Your profile',
								icon: PersonIcon,
								onSelect: () => navigate('/profile'),
							},
							// Running a business day to day (selling, stock, the team) happens in the dashboard app.
							{
								label: 'Open the dashboard',
								icon: DashboardIcon,
								onSelect: () => window.location.assign(dashboardUrl),
							},
						]}
						onLogout={handleLogout}
					/>
				</>
			}
		>
			<Outlet />
		</AppShellLayoutComponent>
	);
}
